/**
 * Het tabblad Leerkrachten: wie er is, iemand uitnodigen (een account
 * aanmaken, met de school erbij), en verwijderen. Verwijderen lukt pas als
 * de leerkracht geen groepen meer heeft; anders zegt de server waarom niet.
 */
import React, { useEffect, useState } from 'react';
import { Plus, Save, Trash2 } from 'lucide-react';
import { beheerApi as api } from '../../../api/beheer';

const LEEG = { username: '', password: '', naam: '', email: '', school_naam: '' };

export function Leerkrachten({ actief, meldFout }) {
  const [leerkrachten, setLeerkrachten] = useState([]);
  const [laden, setLaden] = useState(false);
  const [formulierOpen, setFormulierOpen] = useState(false);
  const [nieuw, setNieuw] = useState(LEEG);

  useEffect(() => {
    if (!actief) return;
    setLaden(true);
    api.haalLeerkrachten().then(setLeerkrachten).catch(err => meldFout(err.message)).finally(() => setLaden(false));
    // eslint-disable-next-line react-hooks/exhaustive-deps -- alleen bij het openen van het tabblad
  }, [actief]);

  const zet = (veld) => (e) => setNieuw({ ...nieuw, [veld]: e.target.value });

  const bewaar = async (e) => {
    e.preventDefault();
    try {
      await api.maakLeerkracht(nieuw);
      setLeerkrachten(await api.haalLeerkrachten());
      setFormulierOpen(false);
      setNieuw(LEEG);
    } catch (err) {
      meldFout(err.message);
    }
  };

  const verwijder = async (id) => {
    if (!window.confirm('Weet je zeker dat je deze leerkracht wilt verwijderen?')) return;
    try {
      await api.verwijderLeerkracht(id);
      setLeerkrachten(leerkrachten.filter(t => t.id !== id));
    } catch (err) {
      meldFout(err.message);
    }
  };

  if (laden) return <p>Laden...</p>;

  return (
    <div className="card">
      <div className="flex-between mb-16">
        <h2>Leerkrachten</h2>
        <button className="btn btn-primary" onClick={() => setFormulierOpen(!formulierOpen)}>
          <Plus size={16} /> Leerkracht uitnodigen
        </button>
      </div>

      {formulierOpen && (
        <form onSubmit={bewaar} className="card" style={{ background: 'var(--vlak)' }} autoComplete="off">
          <div className="grid-2">
            <div className="form-group">
              <label>Gebruikersnaam</label>
              <input type="text" className="input" value={nieuw.username} onChange={zet('username')} autoComplete="new-username" required />
            </div>
            <div className="form-group">
              <label>Wachtwoord</label>
              <input type="password" className="input" value={nieuw.password} onChange={zet('password')} autoComplete="new-password" required />
            </div>
            <div className="form-group">
              <label>Naam</label>
              <input type="text" className="input" value={nieuw.naam} onChange={zet('naam')} required />
            </div>
            <div className="form-group">
              <label>Email</label>
              <input type="email" className="input" value={nieuw.email} onChange={zet('email')} />
            </div>
            <div className="form-group">
              <label>School</label>
              <input type="text" className="input" value={nieuw.school_naam} onChange={zet('school_naam')} />
            </div>
          </div>
          <div className="flex gap-8">
            <button type="submit" className="btn btn-success"><Save size={16} /> Opslaan</button>
            <button type="button" className="btn btn-secondary" onClick={() => setFormulierOpen(false)}>Annuleren</button>
          </div>
        </form>
      )}

      <table>
        <thead>
          <tr>
            <th>Naam</th>
            <th>Gebruikersnaam</th>
            <th>Email</th>
            <th>School</th>
            <th>Acties</th>
          </tr>
        </thead>
        <tbody>
          {leerkrachten.map(l => (
            <tr key={l.id}>
              <td>{l.naam}</td>
              <td>{l.username}</td>
              <td>{l.email || '-'}</td>
              <td>{l.school_naam || '-'}</td>
              <td>
                <button className="btn btn-danger" style={{ padding: '8px 12px' }} onClick={() => verwijder(l.id)}>
                  <Trash2 size={14} />
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
